export default "__VITE_ASSET__9l1gyUfO__"